<div class="door-icon" [class.small]="small">
  <img class="door-icon-img" [appAuthSrc]="img"/>
  <ng-container *ngIf="allowDelete">
    <div
      class="flex-row center-center door-icon-action delete icon-16"
      [class.small]="small"
      [class.icon-12]="small"
      (click)="delete.emit()"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="door.name ?('DOORS.TOOLTIP.DOOR_SHOW'|translate:{doorName:door.name}) : ('DOORS.TOOLTIP.NOT_SHOW'|translate)"
    >
      <mat-icon>close</mat-icon>
    </div>
  </ng-container>

  <div *ngIf="!door?.isSaved"
       class="flex-row center-center door-icon-action add icon-16"
       [class.small]="small"
       [class.icon-12]="small"
       (click)="add.emit()"
  >
    <mat-icon>add</mat-icon>
  </div>
  <mat-menu #addMenu="matMenu" yPosition="below" xPosition="after">
    <button
      mat-menu-item
      (click)="add.emit()"
    >
      {{'DOORS.BUTTONS.NEW'|translate}}
    </button>
    <button
      mat-menu-item
      (click)="addExisting.emit()"
    >
      {{'DOORS.BUTTONS.ADD_TO_EXISTING'|translate }}
    </button>
  </mat-menu>

</div>
